<div class="user-popup">
	<app-user-filter (appFormValue)="updateFilterValue($event)"></app-user-filter>
	<app-user-list [items]="userList$ | async" (selectItems)="selectUsers($event)"></app-user-list>
	<footer class="user-popup__footer">
		<button i18n type="button" appSkin="simple-cancel" (click)="close()">Назад</button>
		<button i18n type="button" appSkin="action-save" (click)="addUser()" [disabled]="!selectedUsers?.length">Добавить</button>
	</footer>
</div>
